/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Drive_Ingest_Approval_DeniedInputs */

const es_components_drive_ingest_approval_denied = /** @type {(inputs: Components_Drive_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta de Drive denegada`)
};

const en_components_drive_ingest_approval_denied = /** @type {(inputs: Components_Drive_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive ingestion denied`)
};

/**
* | output |
* | --- |
* | "Drive ingestion denied" |
*
* @param {Components_Drive_Ingest_Approval_DeniedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_drive_ingest_approval_denied = /** @type {((inputs?: Components_Drive_Ingest_Approval_DeniedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Drive_Ingest_Approval_DeniedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_drive_ingest_approval_denied(inputs)
	return en_components_drive_ingest_approval_denied(inputs)
});
export { components_drive_ingest_approval_denied as "components.drive_ingest_approval.denied" }